import { useState, useEffect, useRef } from 'react';

export const useCountdown = (initialTime) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);

  const timerRef = useRef();

  useEffect(() => {
    if (timeLeft <= 0) return;
    else {
      timerRef.current = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    }

    return () => clearInterval(timerRef.current);
  }, [timeLeft]);

  let hours = Math.floor(timeLeft / 3600);
  let minutes = Math.floor(timeLeft / 60);
  let seconds = Math.floor(timeLeft % 60);

  hours = hours < 10 ? `0${hours}` : hours;
  seconds = seconds < 10 ? `0${seconds}` : seconds;
  minutes = minutes < 10 ? `0${minutes}` : minutes;

  const resetTimer = (sec) => {
    setTimeLeft(sec);
  };

  return { hours, minutes, seconds, resetTimer, isOver: timeLeft <= 0 };
};
